import styled from 'styled-components'

const RunningTextStyle = styled.section`
	--getInTouchDistance: var(--sp15x);
	--countriesDistance: var(--sp18x);

	.flex-align-wrapper {
		display: flex;
		align-items: center;
		margin-left: var(--getInTouchDistance);
	}

	.arr-flex-align-wrapper {
		display: flex;
		align-items: center;
		margin: 0 calc(var(--countriesDistance) / 2);
	}

	.scrolling-wrap {
		display: inline-flex;
		width: auto;

		.duplicate-wrap {
			display: flex;
			align-items: center;
			position: absolute;
			width: 100vw;
			top: 0;
			left: 100%;
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
		--getInTouchDistance: var(--sp10x);
		--countriesDistance: var(--sp14x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
		--getInTouchDistance: var(--sp9x);
		--countriesDistance: var(--sp12x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		--getInTouchDistance: var(--sp9x);
		--countriesDistance: var(--sp12x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		--getInTouchDistance: var(--sp7x);
		--countriesDistance: var(--sp11x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--getInTouchDistance: var(--sp6x);
		--countriesDistance: var(--sp9x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		--getInTouchDistance: var(--sp5x);
		--countriesDistance: var(--sp9x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--getInTouchDistance: var(--sp4x);
		--countriesDistance: var(--sp6x);
	}
`

export default RunningTextStyle
